import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import * as Translations from '../../providers/i18n';
import { toggleAnnotationsVisible } from './actions';

const AnnotationsToggle = ({
    annotationsHidden,
    showAnnotationsToggle,
    toggleAnnotationsVisible,
    i18n
}) => {
    if (!showAnnotationsToggle) {
        return null;
    }

    const toggleAnnotations = (e) => {
        e.preventDefault();

        toggleAnnotationsVisible();
    };

    return (
        <button className="hide-annotations"
            onClick={toggleAnnotations}>
            <i className={`fa ${annotationsHidden ? 'fa-eye' : 'fa-eye-slash'}`}></i>
            {annotationsHidden ?
                i18n.t('attachments_preview.collaboration.annotations.show') :
                i18n.t('attachments_preview.collaboration.annotations.hide')}
        </button>
    );
};

AnnotationsToggle.propTypes = {
    annotationsHidden: PropTypes.bool,
    showAnnotationsToggle: PropTypes.bool,
    toggleAnnotationsVisible: PropTypes.func.isRequired,
    i18n: PropTypes.shape({
        t: PropTypes.func
    })
};

AnnotationsToggle.defaultProps = {
    annotationsHidden: false,
    showAnnotationsToggle: false
};

export default compose(
    Translations.connect,
    connect(
        null,
        { toggleAnnotationsVisible }
    ))(AnnotationsToggle);
